import React, { useEffect, useState,useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {
  Box,
  Paper,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { fetchMonthlySignUpTrend } from "../../../api/nystats";

async function fetchMonthly(days) {
  return Array.from({ length: days }, () => Math.round(Math.random() * 1000));
}

export default function MonthlySignUpTrend() {
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());

  const [main, setMain] = useState([]);
  const [prev, setPrev] = useState([]);
  const filter = useSelector((state) => state.filter);
  const [isLoading, setIsLoading] = useState(true);
    const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);

  // List of months
  const months = Array.from({ length: 12 }).map((_, i) => ({
    label: new Date(0, i).toLocaleString("en", { month: "long" }),
    value: i,
  }));

  // Years start from current year
  const yearOptions = Array.from({ length: 5 }).map((_, i) => new Date().getFullYear() - i);

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const { current, previous } =  await fetchMonthlySignUpTrend({ ...filter, month, year });
      setMain(current);
      setPrev(previous);
    } catch (error) {
      setMain([]);
      setPrev([]);
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [month, year,JSON.stringify(filterWithoutUTM)]);

  const cats = Array.from(
    { length: new Date(year, month + 1, 0).getDate() },
    (_, i) => (i + 1).toString()
  );

  const options = {
    chart: { type: "line", height: 400 },
    title: { text: null },
    xAxis: { categories: cats },
    yAxis: {
      title: {
        text: "Users",
        style: {
          fontSize: "12px",
          fontWeight: "600",
          color: "#000",
        }
      }
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "10px",
            fontWeight: "500",
            textOutline: "none",
            background: '#000',
          }
        }
      }
    },
    series: [
      { name: "Current", data: main, color: "#FD245C" },
      { name: "Previous", data: prev, dashStyle: "ShortDash", color: "#C4C4C4" },
    ],
    credits: { enabled: false },
  };

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: "12px",
        boxShadow: "none",
        border: "1px solid #E8E8E8",
        background: "#fff",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography fontSize={18} fontWeight={600}>
          Monthly Sign-Up Trend
        </Typography>

       {(prev?.length || main?.length) && <Box display="flex" gap={2}>
          {/* Month Autocomplete */}
          <Autocomplete
            options={months}
            value={months.find((m) => m.value === month)}
            onChange={(e, newValue) => setMonth(newValue?.value || 0)}
            popupIcon={<KeyboardArrowDownIcon />}
            sx={{ width: 180 }}
            renderInput={(params) => <TextField {...params} label="Month" />}
          />

          {/* Year Autocomplete */}
          <Autocomplete
            options={yearOptions}
            value={year}
            onChange={(e, newValue) => setYear(newValue)}
            popupIcon={<KeyboardArrowDownIcon />}
            sx={{ width: 150 }}
            renderInput={(params) => <TextField {...params} label="Year" />}
          />
        </Box> }
      </Box>

      {
        isLoading ? <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Loading...
          </Typography>
        </Box> : <>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </>
      }
    </Paper>
  );
}
